<template>
  <v-dialog value="true" max-width="800" persistent scrollable>
    <v-card class="veiculo-dialog" outlined>
      <v-card-title class="veiculo-dialog__title">
        <span>Cadastro de Veículo</span>
        <v-spacer />
        <v-btn icon @click="voltar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pt-6 pb-0">
        <v-form ref="form" v-model="valid" lazy-validation>
                  <v-alert v-if="erroMsg" type="error" dense outlined class="mb-4">{{ erroMsg }}</v-alert>
                  <v-container class="pa-0" fluid>
                    <v-row dense>
                      <v-col cols="12" md="4">
                        <v-text-field label="Placa" v-model="veiculo.placa" :rules="[v => !!v || 'Placa é obrigatória']" required outlined dense></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field label="Marca" v-model="veiculo.marca" outlined dense></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field label="Modelo" v-model="veiculo.modelo" outlined dense></v-text-field>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-text-field label="Ano" v-model="veiculo.ano" type="number" outlined dense></v-text-field>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-text-field label="Cor" v-model="veiculo.cor" outlined dense></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-select label="Tipo" :items="tiposVeiculo" v-model="veiculo.tipo" outlined dense></v-select>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-select label="Status" :items="statusVeiculo" v-model="veiculo.status" outlined dense></v-select>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field label="Chassi" v-model="veiculo.chassi" outlined dense></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field label="Renavam" v-model="veiculo.renavam" outlined dense></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field label="KM na Aquisição" v-model="veiculo.quilometragem_aquisicao" type="number" outlined dense></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field label="Data de Aquisição" v-model="veiculo.data_aquisicao" type="date" outlined dense></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field label="Data de Venda" v-model="veiculo.data_venda" type="date" outlined dense></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions class="px-6 pb-6">
        <v-spacer />
        <v-btn text @click="voltar">Cancelar</v-btn>
        <v-btn class="veiculo-dialog__save" depressed :disabled="!valid" @click="salvarVeiculo">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CadastroVeiculo',
  data() {
    return {
      valid: false,
      erroMsg: '',
      veiculo: {
        placa: '',
        marca: '',
        modelo: '',
        ano: '',
        cor: '',
        tipo: '',
        status: '',
        chassi: '',
        renavam: '',
        quilometragem_aquisicao: '',
        data_aquisicao: '',
        data_venda: '',
      },
      tiposVeiculo: ['Toco', 'Truck', 'Carreta', 'Carro', 'Moto', 'Van', 'Ônibus', 'Outro'],
      statusVeiculo: ['Ativo', 'Vendido', 'Baixado', 'Manutenção'],
    };
  },
  methods: {
    normalizeStatus(status) {
      const statusMap = {
        ATIVO: 'Ativo',
        VENDIDO: 'Vendido',
        BAIXADO: 'Baixado',
        MANUTENCAO: 'Manutenção',
        'MANUTENÇÃO': 'Manutenção',
      };

      const key = String(status || '').trim().toUpperCase();
      return statusMap[key] || String(status || '').trim() || null;
    },

    async salvarVeiculo() {
      this.erroMsg = '';
      if (!this.$refs.form.validate()) {
        this.erroMsg = 'Preencha corretamente o campo Placa.';
        return;
      }
      try {
        const veiculoPayload = {
          placa: this.veiculo.placa,
          marca: this.veiculo.marca,
          modelo: this.veiculo.modelo,
          ano: this.veiculo.ano === '' ? null : this.veiculo.ano,
          cor: this.veiculo.cor,
          tipo: this.veiculo.tipo,
          status: this.normalizeStatus(this.veiculo.status),
          chassi: this.veiculo.chassi,
          renavam: this.veiculo.renavam,
          quilometragem_aquisicao: this.veiculo.quilometragem_aquisicao === '' ? null : this.veiculo.quilometragem_aquisicao,
          data_aquisicao: this.veiculo.data_aquisicao === '' ? null : this.veiculo.data_aquisicao,
          data_venda: this.veiculo.data_venda === '' ? null : this.veiculo.data_venda,
        };
        const veiculoServices = (await import('./veiculoServices.js')).default;
        await veiculoServices.criar(veiculoPayload);
        this.$router.push({ name: 'ListagemVeiculos' });
      } catch (e) {
        this.erroMsg = e?.response?.data?.message || 'Erro ao cadastrar veículo.';
      }
    },
    voltar() {
      this.$router.push({ name: 'ListagemVeiculos' });
    },
  },
};
</script>

<style scoped>
@import "../../assets/inter-font.css";

.veiculo-dialog {
  border-radius: 16px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.veiculo-dialog__title {
  font-weight: 800;
  color: #10b981;
}

.veiculo-dialog__save {
  background-color: #10b981 !important;
  color: #ffffff !important;
  border-radius: 12px;
  text-transform: none;
  font-weight: 800;
}

.body-card-formulario {
  max-height: 100%;
  overflow-y: auto;
  padding-right: 4px;
}
</style>
